import React, { FC } from 'react';
import { ShortcutsListProps } from './types';
import {
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  alpha,
  listItemAvatarClasses,
} from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import { transition } from 'src/theme';

const RowArrowIcon = (
  <ArrowBackIosNew sx={{ fontSize: ({ spacing }) => spacing(1.625) }} />
);

const ShortcutsList: FC<ShortcutsListProps> = ({ shortcuts }) => {
  return (
    <List
      sx={{
        direction: 'rtl',
        height: '100%',
        width: '100%',
        background: 'inherit',
      }}
    >
      {shortcuts.map(({ title, Icon, onClick }) => (
        <ListItemButton
          key={title}
          sx={{
            direction: 'rtl',
            borderBottom: ({ palette }) => `1px solid ${palette.dividerLight}`,
            '&:hover': {
              backgroundColor: ({ palette }) =>
                alpha(palette.primary.light, 0.15),
              [`& .${listItemAvatarClasses.root}`]: {
                transform: ({ spacing }) => `translateX(-${spacing(0.5)})`,
              },
            },
          }}
          onClick={onClick}
        >
          <ListItemIcon sx={{ minWidth: ({ spacing }) => spacing(4) }}>
            {Icon}
          </ListItemIcon>
          <ListItemText
            sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}
            primary={title}
            primaryTypographyProps={{
              fontWeight: 500,
            }}
          />
          <ListItemAvatar
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              transition: transition(),
            }}
          >
            {RowArrowIcon}
          </ListItemAvatar>
        </ListItemButton>
      ))}
    </List>
  );
};

export default ShortcutsList;
